import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-price2-icon',
  templateUrl: './shopping-price2.component.html'
})
export class ShoppingPrice2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
